var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('html',[_c('head'),_c('body',[_c('h1',[_vm._v("Content moderation")]),_c('p',[_vm._v("Simple and neat way to add a blogging feature to add on your website.")]),_c('h4',[_vm._v("Rafael")]),_c('h4',[_vm._v("January 28h, 2024")])])])])
}]

export { render, staticRenderFns }